import api from '.';

export interface DeletePipingProjectDetailPipingListParams {
  projectId: number;
  pipingListId: number;
}

export function deletePipingProjectDetailPipingList(
  params: DeletePipingProjectDetailPipingListParams
): void {
  api.delete(`/piping-project-detail-piping-lists`, { params });
}
